import React from 'react';
import { Header as SharedHeader, type AgencyData, type MenuItem } from '@insieme_dev/shared-ui-react';
import appConfig from '../../config/appConfig';

interface HeaderProps {
  agencyData: AgencyData;
  languageSelector: React.ReactElement;
}

const Header: React.FC<HeaderProps> = ({ agencyData, languageSelector }) => {
  const handleMenuItemClick = (item: MenuItem) => {
    console.log('Menu item clicked:', item);
  };

  return (
    <>
    <div className='top-header'>
      <div className="container-fluid">
        <p className='mb-0'>
          <span className='d-none d-sm-inline'>Sede: </span> 
          <strong>Vada (LI)</strong> - 
          <span className='d-none d-md-inline'> Piazza Garibaldi 76</span>
          <a className="d-md-inline" href="tel:+390586788119">Tel. 0586 788119</a>
          <a className="d-none d-sm-inline" href="tel:+393381740663">Cell. 338 1740663</a>
        </p>
        <p className='mb-0'>
          <span className='d-none d-sm-inline'>Sede: </span> 
          <strong>La Mazzanta (LI)</strong> - 
          <span className='d-none d-md-inline'> Via Valle D'Aosta 50</span>
          <a className="" href="tel:+390586662169">Tel. 0586 662169</a>
          <a className="d-none d-sm-inline" href="tel:+393389838169">Cell. 338 9838169</a>
        </p>
      </div>
    </div>
    <SharedHeader
      agencyData={agencyData}
      languageSelector={languageSelector}
      config={{
        agency: {
          customPhone: appConfig.agency.customPhone || "",
          customMobile: appConfig.agency.customMobile || "",
        },
        socialLinks: {
          whatsapp: appConfig.socialLinks.whatsapp,
          facebook: appConfig.socialLinks.facebook,
          instagram: appConfig.socialLinks.instagram,
          linkedin: appConfig.socialLinks.linkedin,
        },
      }}
      assets={{
        logoPath: "/assets/images/logo.png",
        menuItemsPath: "/locales"
      }}
      className="agenzia-europa-header"
      showLoader={true}
      onMenuItemClick={handleMenuItemClick}
    />
    </>
  );
};

export default Header;